import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from '../models/user';
import { UsersService } from './users.service';

@Injectable({
    providedIn: 'root',
})
export class ThemesService {
    private static readonly DARK_THEME = 'avm-dark-theme';
    private static readonly LIGHT_THEME = 'avm-light-theme';

    private currentTheme: BehaviorSubject<string>;

    public get currentTheme$() {
        return this.currentTheme.asObservable();
    }

    currentUserChange: Subscription;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private usersService: UsersService
    ) {
        this.currentTheme = new BehaviorSubject(ThemesService.DARK_THEME);

        this.currentUserChange = usersService.currentUserChange$.subscribe((currentUser) => {
            if (currentUser) {
                this.changeTheme(this.getUserTheme(currentUser));
            }
        });
    }

    changeTheme(theme: string = null) {
        switch (theme) {
            case ThemesService.DARK_THEME:
                this.document.body.classList.add(ThemesService.DARK_THEME);
                document.body.classList.remove(ThemesService.LIGHT_THEME);
                break;

            case ThemesService.LIGHT_THEME:
                document.body.classList.add(ThemesService.LIGHT_THEME);
                document.body.classList.remove(ThemesService.DARK_THEME);
                break;

            default:
                theme = ThemesService.DARK_THEME;
                document.body.classList.add(ThemesService.DARK_THEME);
                document.body.classList.remove(ThemesService.LIGHT_THEME);
                break;
        }

        this.currentTheme.next(theme);

        sessionStorage.setItem('theme', theme);
    }

    getCurrentTheme() {
        return this.currentTheme.value;
    }

    getUserTheme(user: User): string {
        let userTheme: string;

        const userThemeValue = user?.properties?.find((p) => p.name === 'UI_Theme')?.value;

        if (userThemeValue) {
            userTheme = userThemeValue === 'light' ? ThemesService.LIGHT_THEME : userThemeValue === 'dark' ? ThemesService.DARK_THEME : ThemesService.DARK_THEME;
        }

        return userTheme;
    }
}
